import { AddressDTO } from "./address-dto";
import { PhoneDTO } from "./phone-dto";
import { EmailDTO } from "./email-dto";
import { CustPiiDto } from "./cust-pii-dto";
import { IncomeDTO } from "./income-dto";
import { QuotationEntityIdDto } from "../search/quotation-entity-id-dto";
import { CstCustomer } from './cstCustomer';

export class BorrowerDTO {
    firstName: string;
    middleName: string;
    lastName: string;
    residentialStatus: string;
    ownershipType: string;
    gender: string;
    applicantTypeTypcode: string;
    maritalStatus: string;
    organizationFlag: boolean;
    organizationName: string; //Organisation
    organizationType:string;
    businessType: string;  //Organisation  
    contactPerson: string; //Organisation
    cstPhoneDto: PhoneDTO[] = [];
    gstin: string;  //Organisation
    cstEmailDto: EmailDTO[] = [];
    birthDate: string="";
    birthMonth: string;
    cstCustPiiDto: CustPiiDto[] = [];
    cstAddrDto: AddressDTO[] = [];
    occupationStatus: string;
    relationshipPrimary: string = "";
    cstCustomerEntityId: CstCustomer;
    dealerId: string;
    prefix: string;
    sharableDataFlag: boolean;
    primaryCustFlag: boolean;
    suffix: string;
    nickname: string;
    signupDlrLocId: string;
    homeDlrLocId: string;
    signupDate: string;
    firstEnquireDate: string;
    lastEnquireDate: string;
    custTypcode: string;
    activeFlag: boolean;
    effectiveDate: string;
    expiryDate: string;
    datasourceId: string;
    legalStatcode: string;
    custOrgTypcode: string = "";
    validFlag: boolean;
    validationErrors: string;
    ethnicity: string;
    educationLvl: string;
    annualIncome: string;
    emailContactFlag: boolean;
    mailContactFlag: boolean;
    faxContactFlag: boolean;
    phoneContactFlag: boolean;
    age: string;
    anonFlag: boolean;
    businessName: string;
    source: string;
    langCode: string;
    cstClassId: string = "PORTAL";
    rentFlag: boolean;
    prospectFlag: boolean;
    groupPrivilege: string;
    custOwnerId: string;
    anniversary: string;
    totalSocialActivityCount: string;
    lastPostCount: string;
    createDate: string;
    createUser: string;
    updateDate: string;
    updateUser: string;
    quotationEntityIdDto: QuotationEntityIdDto;
    quotStatusId: string="";
    addrCheckFlag: string="N";
    x: any;
    termAndCondition: boolean;
    isMobileVerified: boolean = false;
    isEmailVerified: boolean = false;
    isPANVerified : boolean = false;
    emailMobileVerifiedID: string;
    isCoApplicantMobileVerified: boolean = false;
    isCoApplicantEmailVerified: boolean = false;
    isCoApplicantPANVerified: boolean = false;
    coApplicantEmailMobileVerifiedID: string;
    coApplicantEmailMobilePANVerifiedID: string;

    constructor() {

        this.cstCustomerEntityId = new CstCustomer();
        for (let i = 0; i < 2; i++) {
            if (this.cstPhoneDto) {
                this.cstPhoneDto[i] = new PhoneDTO();
                if (i == 0) {
                    this.cstPhoneDto[i].phoneTypcode = 'PRIMARY';
                }
                else {
                    this.cstPhoneDto[i].phoneTypcode = 'OTHER';
                }
            }
            if (this.cstEmailDto) {
                this.cstEmailDto[i] = new EmailDTO();
                if (i == 0) {
                    this.cstEmailDto[i].emailTypcode = 'PRIMARY';
                }
                else {
                    this.cstEmailDto[i].emailTypcode = 'OTHER';
                }
            }
            if (this.cstAddrDto) {
                this.cstAddrDto[i] = new AddressDTO();
                if (i == 0) {
                    this.cstAddrDto[i].addressTypcode = 'CURRENT';
                }
                else {
                    this.cstAddrDto[i].addressTypcode = 'PERMANENT';
                }
            }
            if (this.cstCustPiiDto) {
                this.cstCustPiiDto[i] = new CustPiiDto();
                if (i == 0) {
                    this.cstCustPiiDto[i].cstCustPii.doctype = 'PAN';
                }
                else {
                    this.cstCustPiiDto[i].cstCustPii.doctype = 'AADHAR';
                }
            }
        }
    }


}

